import clsx from "clsx"
import { FC } from "react"
import styles from "./DeskFrame.module.scss"
import { default as DeskFrameAngleImg } from "./angle.png"
import { default as DeskFrameSideImg } from "./line-h.png"
import { default as DeskFrameSideVerticalImg } from "./line-v.png"

export const DeskFrame: FC = () => {
  return (
    <div className={clsx(styles.DeskFrame)}>
      <div className={clsx(styles.DeskFrame_angle, styles.tl)}>
        <img src={DeskFrameAngleImg} alt="" />
      </div>
      <div className={clsx(styles.DeskFrame_angle, styles.tr)}>
        <img src={DeskFrameAngleImg} alt="" />{" "}
      </div>
      <div className={clsx(styles.DeskFrame_angle, styles.bl)}>
        <img src={DeskFrameAngleImg} alt="" />{" "}
      </div>
      <div className={clsx(styles.DeskFrame_angle, styles.br)}>
        <img src={DeskFrameAngleImg} alt="" />{" "}
      </div>
      <div
        className={clsx(styles.DeskFrame_side, styles.l)}
        style={{
          backgroundImage: `url(${DeskFrameSideVerticalImg})`
        }}
      />
      <div
        className={clsx(styles.DeskFrame_side, styles.t)}
        style={{
          backgroundImage: `url(${DeskFrameSideImg})`
        }}
      />
      <div
        className={clsx(styles.DeskFrame_side, styles.r)}
        style={{
          backgroundImage: `url(${DeskFrameSideVerticalImg})`
        }}
      />
      <div
        className={clsx(styles.DeskFrame_side, styles.b)}
        style={{
          backgroundImage: `url(${DeskFrameSideImg})`
        }}
      />
    </div>
  )
}
